import { useGLTF } from "@react-three/drei"
// import { blockInfo } from "./ApartmentFinderConfig/blockInfo"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { useCallback, useEffect, useRef, useState } from "react"

import { useStore } from "../../../state/store"
const availableBlocks = Object.keys(blockInfo)

export const useElements = ({ pathToGLTF }) => {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/assets/apartmentfinder/${pathToGLTF}.gltf`)

  console.log(nodes)

  const elementsArr = Object.values(nodes)

  const elements = {}
  elements.meshs = elementsArr.map(e => e.geometry)
  elements.aptID = elementsArr.map(e => e.name.split("-")[3])
  elements.blockID = elementsArr.map(e => e.name.split("-")[3].split("_")[0])
  elements.materialType = elementsArr.map(e => e.name.split("-")[3])
  elements.center = elementsArr.map(e => e.geometry.boundingSphere.center)
  elements.textureName = elementsArr.map(e => e.name.split("-")[1])

  return elements
}
export const useStaticElements = ({ pathToGLTF }) => {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/assets/apartmentfinder/${pathToGLTF}.gltf`)

  const elementsArr = Object.values(nodes)

  const elements = {}
  elements.meshs = elementsArr.map(e => e.geometry)
  elements.objectID = elementsArr.map(e => e.name.split("-")[1])
  elements.textureName = elementsArr.map(e => e.name.split("-")[2])
  elements.materialType = elementsArr.map(e => e.name.split("-")[3])
  // elements.polygonOffset = elementsArr.map(e => e.name.split("-")[3])

  return elements
}

//Deconstruct list of unorganised nodes and structure into blocks
export const useBlocks = ({ pathToGLTF }) => {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/assets/apartmentfinder/${pathToGLTF}.gltf`)
  const { nodes: blockj } = useGLTF(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/interactiveBuildings/ek/blockj.gltf`
  )
  const { nodes: blockh } = useGLTF(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/interactiveBuildings/ek/blockh.gltf`
  )

  console.log(nodes)

  const nodesArr = Object.values(nodes)
  const _blocks = {}

  Object.keys(blockInfo).map(
    (b, i) =>
      (_blocks[b] = nodesArr.filter(n => {
        if (n.name.split("-")[3].split("_")[0].charAt(0) === b) {
          return n
        } else return null
      }))
  )

  _blocks.J = [..._blocks.J, ...Object.values(blockj)]
  _blocks.H = [..._blocks.H, ...Object.values(blockh)]

  console.log(_blocks)

  return _blocks
}

// export const useAvailableApartments = (favePage = false) => {
export const useAvailableApartments = (favePage = false) => {
  const apartments = useStore(state => state.apartments) || []
  const activeBlock = useStore(state => state.activeBlock)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const aspects = useStore(state => state.aspects)
  const favouritesActive = useStore(state => state.favouritesActive)
  const favourites = useStore(state => state.favourites)
  const activeApt = useStore(state => state.activeApt)
  let available

  if (activeApt) {
    available = apartments.filter(a => activeApt === Number(a.PlotNumber))
  } else if (favouritesActive || favePage) {
    available = apartments.filter(a => favourites.includes(a.PlotNumber))
  } else {
    if (activeBlock) {
      available = apartments.filter(
        a =>
          a.Status === "0" &&
          (!bedroomCounts.length || bedroomCounts.includes(parseInt(a.Beds))) &&
          (!bathroomCounts.length ||
            bathroomCounts.includes(parseInt(a["No. Of Bathrooms (including ensuite)"]))) &&
          (!aspects.length || includesAny(aspects, a.Aspect)) &&
          a.PlotNumberPlanning.split(".")[0].toUpperCase().replace(/[0-9]/g, "") ===
            activeBlock.toUpperCase().replace(/[0-9]/g, "")
      )
    } else {
      available = apartments.filter(
        a =>
          a.Status === "0" &&
          (!bedroomCounts.length || bedroomCounts.includes(parseInt(a.Beds))) &&
          (!bathroomCounts.length ||
            bathroomCounts.includes(parseInt(a["No. Of Bathrooms (including ensuite)"]))) &&
          (!aspects.length || includesAny(aspects, a.Aspect))
        // (!aspects.length || aspects.includes(a.Aspect))
      )
    }
  }

  return available
}
// includesAny(aspects, a.Aspect)
export function includesAny(arr, compare) {
  // arr && console.log(arr.split(""))
  // console.log(compare.split("").includes(arr[0]))
  // console.log(compare.split("").includes(arr))
  return compare.split("").includes(arr[0])
}

export const useApartmentBedsByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)

  if (apartments) {
    return apartments.reduce((obj, item) => {
      return Object.assign(obj, { [Number(item.PlotNumber)]: item.Beds })
    }, {})
  }
}
// export const usePlanningNumberByID = () => {
//   const apartments = useStore(state => state.apartments)

//   if (apartments) {
//     return apartments.reduce(
//       (obj, item) => Object.assign(obj, { [Number(item.PlotNumber)]: item.PlotNumberPlanning }),
//       {}
//     )
//   }
// }
export const useBlockIDbyPlotNumber = () => {
  const apartments = useStore(state => state.apartments)

  if (apartments) {
    return apartments.reduce((obj, item) => {
      return Object.assign(obj, { [Number(item.PlotNumber)]: item.PlotNumberPlanning })
    }, {})
  }
}

export const useApartmentStatusByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)
  if (apartments) {
    return apartments.reduce((obj, item) => {
      return Object.assign(obj, { [Number(item.PlotNumber)]: item.Status })
    }, {})
  }
}
export const useApartmentFloorLevelByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)
  if (apartments) {
    return apartments.reduce(
      (obj, item) => Object.assign(obj, { [Number(item.PlotNumber)]: item.FloorLevel }),
      {}
    )
  }
}
export const useApartmentBathsLevelByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)
  if (apartments) {
    return apartments.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [Number(item.PlotNumber)]: item["No. Of Bathrooms (including ensuite)"]
        }),
      {}
    )
  }
}

export const useApartmentBlockNameLevelByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)
  if (apartments) {
    return apartments.reduce(
      (obj, item) => Object.assign(obj, { [Number(item.PlotNumber)]: item.BlockName }),
      {}
    )
  }
}
export const useApartmentTypeByPlotNumber = () => {
  const apartments = useStore(state => state.apartments)

  if (apartments) {
    return apartments.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [Number(item.PlotNumber)]: item.FlatType
        }),
      {}
    )
  }
}

export const useFloorCenter = (blockID, floorNum) => {
  // const center = new Vector3()

  return blockID
}

export const useLongPress = (
  onLongPress,
  onClick,
  { shouldPreventDefault = true, delay = 300 } = {}
) => {
  // console.log("longpressuse");

  const [longPressTriggered, setLongPressTriggered] = useState(false)
  const timeout = useRef()
  const target = useRef()

  const start = useCallback(
    event => {
      timeout.current = setTimeout(() => {
        onLongPress(event)
        setLongPressTriggered(true)
      }, delay)
    },
    [onLongPress, delay]
  )

  const clear = useCallback(
    (event, shouldTriggerClick = true) => {
      timeout.current && clearTimeout(timeout.current)
      shouldTriggerClick && !longPressTriggered && onClick()
      setLongPressTriggered(false)
      if (shouldPreventDefault && target.current) {
        target.current.removeEventListener("touchend", preventDefault)
      }
    },
    [shouldPreventDefault, onClick, longPressTriggered]
  )

  return {
    onPointerDown: e => start(e),
    onTouchStart: e => start(e),
    // ontouchmove: (e) => start(e),
    onPointerUp: e => clear(e),
    // onMouseLeave: (e) => clear(e, false),
    onTouchEnd: e => clear(e)
  }
}

const isTouchEvent = event => {
  return "touches" in event
}

const preventDefault = event => {
  if (!isTouchEvent(event)) return

  if (event.touches.length < 2 && event.preventDefault) {
    event.preventDefault()
  }
}
export function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = event => {
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }
      document.addEventListener("mousedown", listener)
      document.addEventListener("touchstart", listener)
      return () => {
        document.removeEventListener("mousedown", listener)
        document.removeEventListener("touchstart", listener)
      }
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  )
}

export function UseSvg(svg, toFind) {
  let elements = getNestedObject(svg, toFind)
  return elements
}

export function isArr(obj) {
  if (obj instanceof Array) {
    return obj
  } else {
    return Array.prototype.slice.call(obj)
  }
}

export function getNestedObject(object, toFind) {
  let collection = []

  function traverse(object, string) {
    let htmlAsArr = isArr(object)

    for (let i = 0; i < htmlAsArr.length; i++) {
      htmlAsArr[i].id.includes(string) && collection.push(htmlAsArr[i])

      if (isArr(htmlAsArr[i].children)) {
        traverse(htmlAsArr[i].children, string)
        // const result = traverse(htmlAsArr[i].children, string)
        // if (result) return collection
      }
    }
  }

  traverse(object, toFind)

  return collection
}

export function getShapes(arr) {
  let shapes = []

  arr.map(c => isArr(c.children).map(cl => shapes.push(cl)))

  return shapes
}

export function returnSVGID(string, index) {
  return string.split("_")[index].toUpperCase()
}

export const blockHasMultipleBuildings = blockID => {
  return availableBlocks.filter(o => o.charAt(0) === blockID).length > 1
}
export const blockIsAvailable = blockID => {
  // console.log("blockID", blockID)
  // availableBlocks.map(o => console.log(o.includes(blockID)))
  return availableBlocks.filter(o => o.includes(blockID)).length > 0
}
